import {admin, auths, business, client, user, userAuth, overView} from "./client";

export default function addAuthTokenInterceptor(store) {
  const injectAuthHeader = (req) => {
    const token = store.getState().auth.token;
    if (!token) return req;
    req.headers = req.headers || {};
    if (req.headers.Authorization || req.headers.authorization) {
      return req;
    }
    req.headers["Authorization"] = `Bearer ${token}`;
    return req;
  };

  [auths, admin, business, client, user, userAuth, overView].forEach(
    (apiClient) => {
      if (typeof apiClient?.interceptors?.request?.use === "function") {
        apiClient.interceptors.request.use(injectAuthHeader);
      }
    }
  );
}
